import {useSelector} from 'react-redux'
import {getOptimizedRoomsConfig} from 'modules/sapiSearch/selectors'
import {RootState} from 'store'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'
import {roomsToConfigurationObject} from '@vio/core/src/room/business/roomConfiguration'
import {GuestSplit} from '@vio/shared/src/search/GuestPicker/GuestSplitText'

/**
 * Adults/children split of the optimized rooms config, on the B side of the
 * rooms list improvements only. `undefined` on the A side.
 */
export const useGuestSplit = (hotelId: string): GuestSplit | undefined => {
  const toggle = useToggle()
  const isRoomsListImprovementsB = toggle(
    'fb6c24d6-ap-rooms-list-improvements',
    false,
    true
  )
  const roomsString = useSelector((state: RootState) =>
    getOptimizedRoomsConfig(state, hotelId)
  )

  if (!isRoomsListImprovementsB) return undefined

  const {numberOfAdults, numberOfChildren} =
    roomsToConfigurationObject(roomsString)
  return {numberOfAdults, numberOfChildren}
}
